/**
 * Tabbed Product Slider - Simple Tab Switching Logic
 */

// Store current index for each section
const sectionIndices = {};

/**
 * Initialize Swiper for a specific panel
 */
function initializeSwiperForPanel(panel, sectionId) {

  if (typeof Swiper === 'undefined') return;

  const swiperEl = panel.querySelector('.tabbed-product-slider__swiper');
  if (!swiperEl) return;

  // Check if already initialized
  if (swiperEl.swiper) return;

  const blockId = panel.dataset.blockId;
  if (!blockId) return;

  const config = {
    slidesPerView: 1.6,
    spaceBetween: 15,
    breakpoints: {
      600: {
        slidesPerView: 2.4,
        spaceBetween: 20
      },
      1000: {
        slidesPerView: 4.5,
        spaceBetween: 20
      },
      1900: {
        slidesPerView: 5.5,
        spaceBetween: 20
      }
    }
  };

  // Add navigation if buttons exist
  // Search within the current panel using tab index pattern
  const tabIndex = panel.dataset.tabIndex;
  const prevBtn = panel.querySelector('[class*="swiper-button-prev-' + sectionId + '-' + blockId + '"]');
  const nextBtn = panel.querySelector('[class*="swiper-button-next-' + sectionId + '-' + blockId + '"]');
  if (prevBtn && nextBtn) {
    config.navigation = { 
      prevEl: prevBtn, 
      nextEl: nextBtn,
      disabledClass: 'swiper-button-disabled'
    };
  }

  // Add pagination if exists
  const pagination = swiperEl.querySelector('[class*="swiper-pagination-' + sectionId + '-' + blockId + '"]');
  if (pagination) {
    config.pagination = { 
      el: pagination, 
      clickable: true,
      dynamicBullets: false
    };
  }

  // Initialize Swiper
  const swiper = new Swiper(swiperEl, config);
  
  // Store swiper instance for later use
  swiperEl.swiperInstance = swiper;
  
  // Update Swiper after a short delay to ensure panel is visible and DOM is ready
  setTimeout(function() {
    if (swiper) {
      swiper.update();
      swiper.updateSlides();
      swiper.updateSlidesClasses();
      swiper.updateSize();
      swiper.updateAutoHeight();
    }
  }, 150);
}

function showproductOfIndex(product_index, sectionId) {
  // Initialize section index if not exists
  if (sectionIndices[sectionId] === undefined) {
    sectionIndices[sectionId] = 0;
  }

  // Find the section wrapper
  const section = document.querySelector('.tabbed-product-slider-' + sectionId);
  if (!section) return;

  // Get all panels and tabs in this section
  const tabs = section.querySelectorAll('.tabbed-product-slider__tab');

  // Hide current panel
  const currentPanel = section.querySelector(`.tabbed-product-slider__products-panel-${sectionIndices[sectionId]}`);
  if (currentPanel) {
    currentPanel.classList.remove('tabbed-product-slider__products-panel--active');
  }

  // Remove active state from current tab
  tabs.forEach(tab => {
    if (parseInt(tab.dataset.tabIndex) === sectionIndices[sectionId]) {
      tab.classList.remove('tabbed-product-slider__tab--active');
      tab.setAttribute('aria-selected', 'false');
    }
  });

  // Update current index for this section
  sectionIndices[sectionId] = product_index;

  // Show new panel
  const newPanel = section.querySelector(`.tabbed-product-slider__products-panel-${sectionIndices[sectionId]}`);
  if (newPanel) {
    newPanel.classList.add('tabbed-product-slider__products-panel--active');
    
    // Check if Swiper is already initialized for this panel
    const swiperEl = newPanel.querySelector('.tabbed-product-slider__swiper');
    if (swiperEl && swiperEl.swiper) {
      // Swiper already exists, just update it
      setTimeout(function() {
        swiperEl.swiper.update();
        swiperEl.swiper.updateSlides();
        swiperEl.swiper.updateSlidesClasses();
        swiperEl.swiper.updateSize();
      }, 50);
    } else {
      // Initialize Swiper for the newly shown panel
      // Use setTimeout to ensure panel is visible before initializing
      setTimeout(function() {
        initializeSwiperForPanel(newPanel, sectionId);
      }, 50);
    }
  }

  // Add active state to new tab
  tabs.forEach(tab => {
    if (parseInt(tab.dataset.tabIndex) === sectionIndices[sectionId]) {
      tab.classList.add('tabbed-product-slider__tab--active');
      tab.setAttribute('aria-selected', 'true');
    }
  });
}

/**
 * Click dummy nav button: find active panel's hidden swiper button and trigger click
 */
function handleDummyNavClick(sectionId, isNext) {
  const section = document.querySelector('.tabbed-product-slider-' + sectionId);
  if (!section) return;
  const activePanel = section.querySelector('.tabbed-product-slider__products-panel--active');
  if (!activePanel) return;
  const blockId = activePanel.dataset.blockId;
  if (!blockId) return;
  const btnClass = isNext
    ? 'swiper-button-next-' + sectionId + '-' + blockId
    : 'swiper-button-prev-' + sectionId + '-' + blockId;
  const realBtn = activePanel.querySelector('[class*="' + btnClass + '"]');
  if (realBtn) realBtn.click();
}

// Delegate dummy nav clicks (works for dynamically rendered sections)
document.addEventListener('click', function(e) {
  const dummyPrev = e.target.closest('.tabbed-product-slider__dummy-prev');
  const dummyNext = e.target.closest('.tabbed-product-slider__dummy-next');
  if (dummyPrev && dummyPrev.dataset.sectionId) {
    e.preventDefault();
    handleDummyNavClick(dummyPrev.dataset.sectionId, false);
  } else if (dummyNext && dummyNext.dataset.sectionId) {
    e.preventDefault();
    handleDummyNavClick(dummyNext.dataset.sectionId, true);
  }
});

// Initialize Swiper for visible panels on page load
document.addEventListener('DOMContentLoaded', function() {
  if (typeof Swiper === 'undefined') return;

  document.querySelectorAll('.tabbed-product-slider__products-panel--active').forEach(function(panel) {
    const section = panel.closest('.tabbed-product-slider');
    if (!section) return;
    
    // Extract full section ID from class name (handles complex IDs with hyphens and underscores)
    const classList = Array.from(section.classList);
    const sectionIdClass = classList.find(cls => cls.startsWith('tabbed-product-slider-'));
    const sectionId = sectionIdClass ? sectionIdClass.replace('tabbed-product-slider-', '') : null;
    
    if (sectionId) {
      initializeSwiperForPanel(panel, sectionId);
    }
  });
});
